/**
 * Which GST-filing buttons are allowed for a stored return status.
 * The server stores UPPER-CASE statuses (DRAFT | SUBMITTED | FILED); the page used to
 * compare to lower-case 'filed', so nothing was ever disabled after filing.
 * The server refuses Prepare once a return is SUBMITTED or FILED — the page must too.
 */
export function filingFlags(status: string | null | undefined) {
  const s = String(status ?? '').toUpperCase();
  const filed = s === 'FILED';
  const submitted = s === 'SUBMITTED';
  return {
    canPrepare: !filed && !submitted,
    canSubmit: !!s && !filed && !submitted,
    canRequestOtp: submitted,
    canFile: submitted,
  };
}
